import { gql } from 'graphql-request';

const request = {
	request: {
		name: 'auth>user_token_verify'
	},

	gql: {
		schema: gql`
      query UserTokenVerify(
      	$token: String
      ) {
      	request(
      		token: $token
      	) {
      		status
      	}
      }
		`
	}
};

export default request;
